import {get, post,put,deletes} from './http';

// 登录注册
export const login = p =>post('/nosecure/mem/password/login',p) //用户名密码登录

export const PhoneLogin = p =>post('/nosecure/mem/sms/login',p) //手机号验证码登录

export const MemRegister = p =>post('/nosecure/mem/register',p) //注册

export const smsCode = p =>post('/util/smsCode/create?phone=' + p) //短信验证码

// 发票设置

export const MemInvoice = (params = {}) => get({url:'/mem/invoice',params}) //获取发票信息信息

export const SaveInvoice = p =>post('/mem/invoice/save', p) //保存发票信息信息

//个人信息
export const MemInfo = (params = {}) => get({url:'/mem/info',params}) //会员信息

export const SaveMemInfo = p =>post('/mem/info/save', p) //保存会员信息

//首页信息

export const homeProduct = (params = {}) => get({url:'/nosecure/home/product',params})//首页楼层产品信息

export const homeAd = (params = {}) => get({url:'/nosecure/home/ad',params})//首页广告图片

// 产品

export const prodDetail = p =>post(`/nosecure/prod/detail/${p}`) //产品详情

export const category = (params = {}) => get({url:'/nosecure/layout/category',params})//分类列表

// 搜索

export const prodSearch = p =>post('/nosecure/prod/search',p) //产品搜索

export const prodPopular = (params = {}) => get({url:'/nosecure/prod/popular',params}) //热门搜索

// 地址

export const MemAddress = (params = {}) => get({url:'/mem/address/list',params}) //地址列表

export const AddressDetail = params => get({url:`/mem/address/${params}`}) //单条地址详情

export const AddAddress = p => post('/mem/address',p) //新增地址

export const EditAddress = (p,data) => put(`/mem/address/${p}`,data) //修改当前地址

export const DeleteAddress = p => deletes(`/mem/address/${p}`) //删除当前地址

//物流
// export const OrderLogistics = p => deletes(`/ord/sale/logistics`,p) //查看物流

//订单
export const SaleOrder = (params = {}) => get({url:'/ord/sale/count',params})//获取个人中心订单类型数量

export const SaleOrderDetail = params => get({url:`/ord/sale/${params}`})//获取订单详情信息

export const SaleAllOrder = p => post('/ord/sale/list/all',p) //全部订单列表

export const SaleWaitOrder = p => post('/ord/sale/list/waitPaid',p) //待支付订单列表

export const SaleWaitshipOrder = p => post('/ord/sale/list/waitShip',p) //待发货订单列表

export const SaleWaitreceiptOrder = p => post('/ord/sale/list/waitReceipt',p) //待收货订单列表 

export const SaleWaitliftingOrder = p => post('/ord/sale/list/waitLifting',p) //待自提订单列表   

export const Lifting = p => post(`/ord/sale/lifting/${p}`) //确认自提

export const Receipt = p => post(`/ord/sale/receipt/${p}`) //确认收货

export const CancelOrder = p => post(`/ord/sale/cancel/${p}`) //取消订单

//购物车
export const shopCartList = (params = {}) => get({url:'/shop/cart/list',params})//获取购物车列表

export const addCart = p => post(`/shop/cart`,p) //添加到购物车

export const deleteCart = (p = {}) => deletes(`/shop/cart`,p) //购物车删除

export const shopCartSettle = p => post(`/shop/cart/settle`,p) //结算订单详情

export const CartNum = (p,data) => put(`/shop/cart/${p}`,data) //更改购物车数量

export const OrderCreate = p => post(`/shop/order/create`,p) //订单生成

// 支付
export const OutlineOrder = params => get({url:`/pay/${params}`})//根据销售编号查询线下支付信息

export const Upload = (p,config) => post(`/util/upload`,p,config)//上传

export const payOffice = (p,data) => post(`/pay/offline/save/${p}`,data) //保存线下支付

export const WXpay = p => post(`/pay/weixin/create/${p}`) //微信支付

export const Alipay = p => post(`/pay/ali/create/${p}`) //支付宝支付















 